"use client";

import {
  Button,
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerTitle,
  DrawerTrigger,
  FilterIcon,
  type GameFilterGroup,
  GameFilterPanel,
} from "@workspace/frontend-ui";
import { useCallback, useState } from "react";
import useFilterSelect from "./useFilterSelect";

type Props = {
  title: string;
  groups: GameFilterGroup[];
  clearLabel: string;
  applyLabel: string;
};

const FiltersDrawer: FC<Props> = ({
  title,
  groups,
  clearLabel,
  applyLabel,
}) => {
  const [open, setOpen] = useState(false);
  const { clear, select } = useFilterSelect(groups);

  const clearAndClose = useCallback(() => {
    clear();
    setOpen(false);
  }, [clear]);

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button
          variant="secondary"
          size="icon"
          aria-label={title}
          className="size-10 shrink-0 rounded-xl lg:hidden"
          data-testid="all-games-filters-trigger"
        >
          <FilterIcon className="size-5" />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="border-0">
        <DrawerTitle className="px-4 pt-4 text-base font-semibold">
          {title}
        </DrawerTitle>
        <div className="overflow-y-auto p-4">
          <GameFilterPanel
            title={title}
            showTitle={false}
            groups={groups}
            selectAction={select}
          />
        </div>
        <DrawerFooter className="flex-row gap-2">
          <Button variant="outline" className="flex-1" onClick={clearAndClose}>
            {clearLabel}
          </Button>
          <DrawerClose asChild>
            <Button className="flex-1">{applyLabel}</Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default FiltersDrawer;
